__turbopack_context__.v({
  "disabled": "Flag-module__lGZrCG__disabled",
  "flag": "Flag-module__lGZrCG__flag",
  "selected": "Flag-module__lGZrCG__selected",
});
